<template>
  <div class="main pass-add">
    <div class="form-row">
      <div class="form-field">
        <label for="user-select">Выберите пользователя:</label>
        <select id="user-select" v-model="idUser" v-on:change="setUserData">
          <option v-for="(user, key) in users" :value="key" :key="key">{{
            user.FIO
          }}</option>
        </select>
      </div>
    </div>
    <div class="form-row" v-if="userData">
      <div class="form-field">
        <label for="auto-number-input">Введите номер ТС:</label>
        <input id="auto-number-input" v-model="autoData.number" type="text" />
      </div>
      <div class="form-field">
        <label for="auto-type-select">Выберите тип ТС:</label>
        <select id="auto-type-select" v-model="autoData.autoType">
          <option value="passenger">Легковой</option>
          <option value="cargo">Грузовой</option>
        </select>
      </div>
      <div class="form-field">
        <label for="access-group-select">Выберите группу доступа:</label>
        <select id="access-group-select" v-model="autoData.accessGroup">
          <option value="owner">Собственник</option>
          <option value="guest">Гость</option>
          <option value="truck">Грузовик</option>
        </select>
      </div>
      <div class="form-field">
        <label for="access-type-select">Выберите тип доступа:</label>
        <select id="access-type-select" v-model="autoData.accessType">
          <option value="temporary">Временный</option>
          <option value="constant">Постоянный</option>
        </select>
      </div>
      <div class="form-field" v-if="autoData.accessType === 'temporary'">
        <label for="date-from-input">Начало периода:</label>
        <input id="date-from-input" type="date" v-model="autoData.dateFrom" />
        <label for="date-to-input">Конец периода:</label>
        <input id="date-to-input" type="date" v-model="autoData.dateTo" />
        <label for="entry-limit-input">Количество проходов(max:127):</label>
        <input
          id="entry-limit-input"
          type="number"
          v-model="autoData.entryLimit"
        />
      </div>
      <div class="form-field">
        <img v-show="waite" src="@/assets/wait.gif" class="waite" />
        <button v-show="!waite" @click="sendAutoData">Отправить</button>
      </div>
    </div>
    <div class="form-row" v-if="info">{{ info }}</div>
  </div>
</template>

<script>
import config from "@/config";

export default {
  name: "PassAdd",
  props: ["user"],
  data() {
    return {
      url: config.backend_url,
      users: {},
      autoData: {
        userId: null,
        number: null,
        autoType: null,
        accessType: null,
        accessGroup: null,
        entryLimit: null,
        dateFrom: null,
        dateTo: null
      },
      idUser: this.user,
      userData: false,
      info: false,
      waite: false
    };
  },
  methods: {
    sendAutoData: function() {
      let self = this;
      self.waite = true;
      self.autoData.userId = self.idUser;
      let data = {
        url: self.url + "pass/add/",
        data: self.autoData,
        method: "POST"
      };
      this.$store.dispatch("query/sendRequest", data).then(function(response) {
        let data = response.data;
        if (data.error) {
          self.info = data.error;
        } else {
          self.info = data.parsecPersonID
            ? "ID пользователя: " + data.parsecPersonID
            : "Ошибка добавления пропуска в Parsec";
          console.log(data);
        }
        self.waite = false;
      });
    },
    setUserData: function() {
      this.userData = this.users[this.idUser];
    }
  },
  mounted() {
    let self = this;
    let data = {
      url: this.url + "users/get/",
      data: {},
      method: "POST"
    };
    this.$store.dispatch("query/sendRequest", data).then(response => {
      let data = response.data;
      if (data) {
        self.users = data;
      } else {
        self.info = "Ошибка получения списка пользователей";
      }
      if (self.idUser) {
        self.setUserData();
      }
    });
  }
};
</script>
